import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetUsersUserIdRiskDirectoriesSuspense } from "api/generated/users/users";

export function useRiskDirectoriesForUserQuery(userId: number) {
    return useGetUsersUserIdRiskDirectoriesSuspense(userId, {
        query: {
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
